const API_REQUEST = '[API] API';

export default API_REQUEST;
